import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators'
import store from '@/store'
import { IVendor, IVendorItem } from '@/api/types-vendor'

export const defaultVendorItemData: IVendorItem = {
  vendorId: 0,
  firstName: '',
  lastName: '',
  email: '',
  paymentMethod: '',
  phone: '',
  phone2: '',
  address: '',
  city: '',
  state: '',
  postalCode: '',
  vendorCompanyId: 0,
  vendorTypeId: 0,
  vendorStatusId: 0,
  vendorRoleId: 0,
  displayName: '',
  vendorCompanyName: '',
  deleted: false
}

export const defaultVendorData: IVendor = {
  vendorId: 0,
  firstName: '',
  lastName: '',
  email: '',
  paymentMethod: '',
  phone: '',
  phone2: '',
  address: '',
  city: '',
  state: '',
  postalCode: '',
  latitude: 0,
  longitude: 0,
  vendorCompanyId: 0,
  vendorTypeId: 0,
  accountingId: '',
  vendorStatusId: 0,
  vendorRoleId: 0,
  vendorRank: 0,
  vendorPhoto: '',
  haltAssignStart: null,
  haltAssignStop: null,
  dailyOrderLimit: 0,
  verified: false,
  verificationNote: '',
  performance: 0,
  ordersAssigned: 0,
  ordersInProcess: 0,
  ordersLate: 0,
  ordersOnHold: 0,
  ordersCompleted: 0,
  ordersDeclined: 0,
  notifyMode: '',
  notifyOnSubmit: false,
  notifyOnLostBid: false,
  notifyOnReAssign: false,
  deleted: false
}

export interface IVendorsState {
  VendorList: IVendorItem[]
  VendorSelected: (IVendor | null)
  VendorSearch: (string | null)
}

@Module({ dynamic: true, store, name: 'Vendor' })
class Vendors extends VuexModule implements IVendorsState {
  public VendorList: IVendorItem[] = []
  public VendorSelected: IVendor | null = null
  public VendorSearch: string | null = null

  @Mutation
  private DEL_ALL_VENDORS() {
    this.VendorList = []
  }

  @Mutation
  private LOAD_VENDORS(Vendors: IVendorItem[]) {
    this.VendorList = Vendors
  }

  @Mutation
  private SET_SELECTED(Vendor: IVendor | null) {
    this.VendorSelected = Vendor
  }

  @Mutation
  private SET_SEARCH(searchValue: string | null) {
    this.VendorSearch = searchValue || ''
  }

  @Mutation
  private UPDATE_VENDOR(Vendor: IVendor) {
    for (const v of this.VendorList) {
      if (v.vendorId === Vendor.vendorId) {
        // v = Object.assign(v, Vendor) // do not update the list
        v.address = Vendor.address
        v.city = Vendor.city
        v.state = Vendor.state
        v.postalCode = Vendor.postalCode
        v.email = Vendor.email
        v.lastName = Vendor.lastName
        v.firstName = Vendor.firstName
        break
      }
    }
  }

  @Action
  public createNewItem(): IVendor {
    const v: IVendor = defaultVendorData
    return v
  }

  @Action
  public getSearch(): string {
    const v: string = this.VendorSearch
    return v || ''
  }

  @Action
  public loadVendors(Vendors: IVendorItem[]) {
    this.DEL_ALL_VENDORS()
    this.LOAD_VENDORS(Vendors)
  }

  @Action
  public setSelectedVendor(Vendor: IVendor) {
    this.SET_SELECTED(Vendor)
  }

  @Action
  public updateVendor(Vendor: IVendor) {
    if (this.VendorSelected == null) return
    if (this.VendorSelected.vendorId !== Vendor.vendorId) return
    this.SET_SELECTED(Vendor)
    this.UPDATE_VENDOR(Vendor)
  }

  @Action
  public updateSearch(searchValue: string | null) {
    this.SET_SEARCH(searchValue || '')
  }
}

export const VendorsModule = getModule(Vendors)
